module.exports = __webpack_public_path__ + "static/img/200158.3dfca213.png";